import React from "react";

export default function DryRunModal({ preview, onCancel, onExecute, executing }) {
  if (!preview) return null;
  return (
    <div className="fa-modal-backdrop">
      <div className="fa-modal max-w-2xl">
        <div className="border-b border-slate-200 p-4">
          <h2 className="text-lg font-bold">Dry run preview</h2>
          <p className="text-sm text-slate-500">Nothing is written until you click Execute.</p>
        </div>
        <div className="space-y-3 p-4 text-sm">
          <p><strong>Affected documents:</strong> {preview.affectedDocuments}</p>
          <p><strong>Changed fields:</strong> {preview.changedFields?.join(", ") || "—"}</p>
          <p><strong>Estimated writes:</strong> {preview.estimatedWrites}</p>
          <p><strong>Estimated time:</strong> ~{preview.estimatedSeconds}s</p>
          {preview.warnings?.length > 0 && (
            <div className="rounded-lg bg-amber-50 p-3 text-amber-900">
              {preview.warnings.map((w, i) => (
                <p key={i}>⚠ {w}</p>
              ))}
            </div>
          )}
          <div className="max-h-48 overflow-auto rounded-lg border border-slate-200">
            <table className="fa-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Before</th>
                  <th>After</th>
                </tr>
              </thead>
              <tbody>
                {(preview.changes || []).map((c) => (
                  <tr key={c.id}>
                    <td className="font-mono text-xs">{c.id}</td>
                    <td className="max-w-[200px] truncate font-mono text-xs">
                      {JSON.stringify(c.before)?.slice(0, 80)}
                    </td>
                    <td className="max-w-[200px] truncate font-mono text-xs">
                      {c.after == null ? "(deleted)" : JSON.stringify(c.after)?.slice(0, 80)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="flex justify-end gap-2 border-t border-slate-200 p-4">
          <button type="button" className="fa-btn" onClick={onCancel} disabled={executing}>Cancel</button>
          <button type="button" className="fa-btn fa-btn-danger" onClick={onExecute} disabled={executing}>
            {executing ? "Executing…" : "Execute"}
          </button>
        </div>
      </div>
    </div>
  );
}
